// extracted by mini-css-extract-plugin
export var CopyContainer = "Copy-module--CopyContainer--1YnSp";
export var Markdown = "Copy-module--Markdown--2tiY9";